import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MessageBox from 'syf-component-library/ui/patterns/MessageBox';
import Inset from 'syf-component-library/ui/spacing/Inset';
import Body from 'syf-component-library/ui/typography/Body';
import { colors } from '../../../defaultTheme';
import { t } from '../../../strings/i18n';
import HandHeart from '../../atoms/HandHeart';
import CAPInformation from './CAPInformation';
const CAPMessageBox = ({ paymentAmount }) => {
    return (_jsxs(MessageBox, Object.assign({ icon: _jsx(HandHeart, { color: colors.darkWarning, height: "60", width: "60" }), type: "warning" }, { children: [_jsx(Inset, Object.assign({ left: "base" }, { children: _jsx(Body, Object.assign({ isInline: true, weight: "bold" }, { children: t('text.accountIsEnrolledInCAP') })) })), _jsx(CAPInformation, { paymentAmount: paymentAmount })] })));
};
export default CAPMessageBox;
